<template>
  <tr>
    <td class="text-truncate" >{{fss.rliss}}</td>
    <td class="text-truncate" >
      <a :href="url" @click="details()">{{fss.agency_name}}</a>
    </td>
    <td>
      <template v-if="fss.statut_id_m1==fss.statut_id_0">
        {{fss.statut_m1}}
      </template>
      <template v-else="">
        {{fss.statut_m1}} &rarr; {{fss.statut_0}}
      </template>
    </td>
    <td v-text="fss.statut_plan_0"></td>
    <td :class="clienteleClass" style="text-align: center;">
      {{clients_m1}} &rarr; {{clients_0}}
    </td>

    <td :class="hrClass" style="text-align: center;">
      {{hr_m1}} &rarr; {{hr_0}}
    </td>

    <td style="text-align: center;">
      <template v-if="fss.statut_id_m1!=4">
        {{fss.ec_m1}} &rarr; {{fss.ec_0}}
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'FssDiffRow',
  props: {
    fss: Object
  },
  computed: {
    url() {
      return '/on/comparaison/'+this.fss.agency_id;
    },
    hr_0() {
      return this.fss.statut_id_0==4 ? this.fss.hr_ni_actuel_0 : this.fss.hr_id_actuel_0;
    },
    hr_m1() {
      return this.fss.statut_id_m1==4 ? this.fss.hr_ni_actuel_m1 : this.fss.hr_id_actuel_m1;
    },
    hrClass() {
      const a = this.hr_m1;
      const b = this.hr_0;

      if(a==b)
        return "";
      if(b==0) // flag no entries
        return "table-secondary"

      if(Math.abs(b-a)<=2)
        return "";
      const percentChange = 100*(b-a)/a;
      if(percentChange>=25) return "table-success";
      if(percentChange>=10) return "table-info";
      if(percentChange<=-25) return "table-danger";
      if(percentChange<=-10) return "table-warning";
      return "";
    },

    clienteleClass() {
      const a = this.fss.clientele_m1;
      const b = this.fss.clientele_0;
      if(b==0 & a!=0)
        return "table-danger";
      if(b==0) // flag no entries
        return "table-warning";
      return"";
    },

    clients_m1() {
      if(this.fss.clientele_m1!=0)
        return this.fss.clientele_m1;
      if(this.fss.visites_m1!=0)
        return "V: "+this.fss.visites_m1;
      return 0;
    },
    clients_0() {
      if(this.fss.clientele_0!=0)
        return this.fss.clientele_0;
      if(this.fss.visites_0!=0)
        return "V: "+this.fss.visites_0;
      return 0;
    },
  },
  methods: {
    details() {
      this.$router.push('/on/comparaison/'+this.fss.agency_id);
      return false;
    }
  }
}
</script>
<style>
progress {
  width: 100px;
}
</style>
